var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkCheveronUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5798 0.89565C12.1401 1.42318 12.1401 2.27849 11.5798 2.80602L7.01447 7.10435C6.45417 7.63188 5.54574 7.63188 4.98544 7.10435C4.42514 6.57682 4.42514 5.72151 4.98544 5.19398L9.55075 0.89565C10.111 0.368117 11.0195 0.368116 11.5798 0.89565Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01447 7.10435C6.45417 7.63188 5.54574 7.63188 4.98544 7.10435L0.420225 2.80668C-0.140075 2.27914 -0.140075 1.42384 0.420225 0.896306C0.980525 0.368773 1.88895 0.368772 2.44925 0.896306L7.01456 5.19464C7.57486 5.72217 7.57477 6.57682 7.01447 7.10435Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCheveronUp);
export default __webpack_public_path__ + "static/media/dark-cheveron-up.33628d77ba49a6abdb37345b107ba0ff.svg";
export { ForwardRef as ReactComponent };